module.exports = __webpack_public_path__ + "img/MoDesk7.b65aa464.png";